module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9jMyS"))).then(() => parcelRequire('hEqeo'));